import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {LookUpPage} from './look-up';
import {TranslateModule} from "@ngx-translate/core";
import {GetKeysPipe} from "../../pipes/utils/get-keys-pipe";
import {HeaderTitleComponentModule} from '../../components/header-title/header-title.module';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  declarations: [
    LookUpPage,
    GetKeysPipe
  ],
  imports: [
    HeaderTitleComponentModule,
    IonicPageModule.forChild(LookUpPage),
    TranslateModule.forChild(),
    PipesModule,
    DirectivesModule,
    ComponentsModule
  ],
})
export class LookUpPageModule {}



// WEBPACK FOOTER //
// ./src/pages/look-up/look-up.module.ts